<template>
	<div>
		<div class="help desktop">
			<label>Title</label>
			<div class="inner">
				<label>Timeframe</label>
				<label>Size</label>
			</div>
		</div>
		<p class="help mobile">
			Each leaderboard has an <strong>optional title</strong>, a <strong>timeframe</strong> and a
			<strong>number of results</strong> to display.
		</p>
		<SortableList v-if="value.length" :value="value" @input="update" keyProp="range">
			<LeaderboardForm
				v-for="(leaderboard, index) of value"
				:key="leaderboard.range"
				:ranges="getRanges(leaderboard.range)"
				v-model="value[index]"
			/>
		</SortableList>
		<p class="empty" v-else>Add a leaderboard below.</p>
		<hr />
		<AddLeaderboardForm v-if="unusedRanges.length" :ranges="unusedRanges" @add="onAdd" />
	</div>
</template>

<script>
import { LeaderboardRange } from 'recycle-race-common/lib/enums'
import SortableList from '@/components/SortableList'
import LeaderboardForm from '@/forms/LeaderboardForm'
import AddLeaderboardForm from '@/forms/AddLeaderboardForm'

export default {
	name: 'Leaderboards',
	props: {
		value: Array,
		ranges: {
			type: Array,
			default: () => Object.keys(LeaderboardRange),
		},
	},
	computed: {
		unusedRanges() {
			return this.ranges.filter(range => {
				return this.value.every(item => item.range !== range)
			})
		},
	},
	methods: {
		getRanges(key) {
			// Return array including only unused ranges and
			// leaderboard's current range
			return this.ranges.filter(range => {
				return range === key || this.unusedRanges.includes(range)
			})
		},
		update(value) {
			this.$emit('input', value)
		},
		onAdd(leaderboard) {
			this.update([...this.value, leaderboard])
		},
	},
	components: {
		SortableList,
		LeaderboardForm,
		AddLeaderboardForm,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/layout';

.help {
	&.desktop {
		display: none;
		padding: 0.5rem 8.5rem 0.5rem 0.5rem;

		.inner {
			@include row(md);
		}

		label {
			font-weight: bold;
		}
	}

	@include mq(lg) {
		&.mobile {
			display: none;
		}
		&.desktop {
			@include row;
		}
	}
}

.empty {
	padding: 0 0.5rem;
}
</style>
